<div class="consult-table-section">
  <p class="consult-table-summary" aria-live="polite">{{ operationsFoundLabel }}</p>

  <div class="consult-table-shell">
    <b3-table
      size="sm"
      background="striped"
      aria-label="Lista de operações"
      [attr.aria-rowcount]="totalItens"
      aria-colcount="8">
      <b3-table-rowgroup group="header">
        <b3-table-row>
          <b3-table-cell-header label="Data da Operação"></b3-table-cell-header>
          <b3-table-cell-header label="Cod. Instr. Financeiro"></b3-table-cell-header>
          <b3-table-cell-header label="Conta Registrador"></b3-table-cell-header>
          <b3-table-cell-header label="Conta Detentor"></b3-table-cell-header>
          <b3-table-cell-header label="Qnt." align="end"></b3-table-cell-header>
          <b3-table-cell-header label="Tipo da Operação"></b3-table-cell-header>
          <b3-table-cell-header label="Nº de Controle"></b3-table-cell-header>
          <b3-table-cell-header label="Detalhes" align="center"></b3-table-cell-header>
        </b3-table-row>
      </b3-table-rowgroup>

      <b3-table-rowgroup group="body">
        <b3-table-row
          *ngFor="let operation of itens; trackBy: trackByOperationCode"
          [id]="'operation-row-' + operation.operationCode">
          <b3-table-cell variant="text" [label]="operation.insertDate || '-'"></b3-table-cell>
          <b3-table-cell variant="text" [label]="operation.carbonCreditCode || '-'"></b3-table-cell>
          <b3-table-cell variant="text" [label]="operation.registerCode || '-'"></b3-table-cell>
          <b3-table-cell variant="text" [label]="operation.holderCode || '-'"></b3-table-cell>
          <b3-table-cell variant="number" [label]="formatQuantity(operation.creditQuantity)"></b3-table-cell>
          <b3-table-cell variant="tag">
            @let operationTypeBadge = getOperationTypeBadge(operation);
            <b3-tag
              size="sm"
              variant="filled"
              [icon]="operationTypeBadge.icon"
              [tone]="operationTypeBadge.tone"
              [label]="operationTypeBadge.label">
            </b3-tag>
          </b3-table-cell>
          <b3-table-cell variant="slot">
            @let controlNumber = getOperationControlNumber(operation);
            <b3-tooltip
              *ngIf="controlNumber; else emptyControlNumber"
              [label]="controlNumber"
              variant="single-line"
              pointer="right">
              <button
                type="button"
                class="consult-table-control-number"
                [attr.aria-label]="getOperationControlNumberAriaLabel(operation)"
                (click)="copyOperationControlNumber(operation, $event)">
                {{ controlNumber }}
              </button>
            </b3-tooltip>
            <ng-template #emptyControlNumber>
              <span class="consult-table-control-number consult-table-control-number--empty">-</span>
            </ng-template>
          </b3-table-cell>
          <b3-table-cell variant="slot">
            <div class="consult-table-actions">
              <b3-button
                type="button"
                variant="ghost"
                tone="default"
                size="sm"
                [attr.aria-label]="getOperationDetailLabel(operation)"
                (b3-click)="openDetail(operation)">
                <b3-icon name="visibility"></b3-icon>
              </b3-button>
            </div>
          </b3-table-cell>
        </b3-table-row>
      </b3-table-rowgroup>
    </b3-table>
  </div>

  <div class="consult-table-pagination" *ngIf="totalPages > 1">
    <p class="consult-table-pagination__info">{{ recordsPerPageLabel }}</p>
    <b3-pagination
      aria-label="Paginação de operações"
      variant="numbers"
      navigation="icon"
      overflow
      [attr.total]="totalPages"
      [attr.current]="pagination.page ?? 1"
      (b3-change)="onPaginationChange($event)">
    </b3-pagination>
  </div>
</div>
